/* eslint-disable */
/* global jQuery, Shopify */
(function() {
  function initSystemProductTabs(event) {
    const sections = document.querySelectorAll('.system-tabs-section');
    sections.forEach(section => {
      // Check if we are loading a specific section via Theme Editor
      if (event && event.type === 'shopify:section:load') {
        if (section.dataset.sectionId !== event.detail.sectionId) {
          return; 
        }
      }
      
      if (section.dataset.initialized === 'true' && (!event || event.type !== 'shopify:section:load')) {
         return;
      }
      section.dataset.initialized = 'true';

      const tabs = section.querySelectorAll('.system-tab-btn');
      const contents = section.querySelectorAll('.system-tab-content');
      const prevTabBtn = section.querySelector('.prev-tab');
      const nextTabBtn = section.querySelector('.next-tab');
      let activeTabIndex = 0;

      // ── Owl helpers (mobile only) ──────────────────────────────────────────
      function destroyOwl(owlContainer) {
        if (!owlContainer || typeof jQuery === 'undefined') return;
        const $el = jQuery(owlContainer);
        if ($el.hasClass('owl-loaded')) {
          $el.trigger('destroy.owl.carousel');
          $el.removeClass('owl-loaded owl-hidden');
          if ($el.find('.owl-stage-outer').length) {
            $el.find('.owl-stage-outer').children().unwrap();
          }
        }
      }

      function initOwl(owlContainer) {
        if (!owlContainer || typeof jQuery === 'undefined' || !jQuery.fn.owlCarousel) return;
        if (owlContainer.offsetParent === null) return;
        if (owlContainer.dataset.owlInitializing === 'true') return;
        
        owlContainer.dataset.owlInitializing = 'true';
        
        try {
          const $el = jQuery(owlContainer);
          
          if ($el.hasClass('owl-loaded')) {
            $el.trigger('destroy.owl.carousel');
            $el.removeClass('owl-hidden');
          }
          
          if ($el.children('.item').length === 0) {
            owlContainer.dataset.owlInitializing = 'false';
            return;
          }
          
          $el.owlCarousel({
            loop: true,
            margin: 10,
            responsiveClass: true,
            responsive: {
              0:    { items: 1, nav: false, dots: true },
              600:  { items: 2, nav: false, dots: true },
              1000: { items: 5, nav: true, loop: false }
            }
          });
        } catch (e) {
          console.error('Owl init error:', e);
        }
        
        owlContainer.dataset.owlInitializing = 'false';
      }

      // ── Pagination ─────────────────────────────────────────────────────────
      function paginate(tabId) {
        const container = section.querySelector('#' + tabId);
        if (!container) return;

        const owlContainer = container.querySelector('.products-grid');
        const isDesktop = window.innerWidth > 768;

        if (isDesktop) {
          destroyOwl(owlContainer);
          if (owlContainer) owlContainer.classList.remove('owl-carousel');
        } else {
          destroyOwl(owlContainer);
          if (owlContainer) owlContainer.classList.add('owl-carousel');
        }

        const cards = Array.from(container.querySelectorAll('.product-item'));
        const perPage = parseInt(section.dataset.productsPerPage, 10) || 9;
        const pagination      = container.querySelector('.custom-pagination');
        const paginationNums  = container.querySelector('.pagination-numbers');
        const prevBtn         = container.querySelector('.prev-page');
        const nextBtn         = container.querySelector('.next-page');
        let currentPage = 1;

        function render() {
          const start = (currentPage - 1) * perPage;
          const end   = start + perPage;
          cards.forEach((card, i) => {
            const isVisible = (i >= start && i < end);
            card.style.display = isVisible ? '' : 'none';
            card.classList.toggle('hidden', !isVisible);
          });
          renderButtons();
        }

        function getPaginationArray(c, m) {
          if (m <= 7) {
            const r = [];
            for (let i = 1; i <= m; i++) r.push(i);
            return r;
          }
          let delta = 1, left = c - delta, right = c + delta + 1;
          if (c <= 3)       { left = 1;     right = 6; }
          else if (c >= m - 2) { left = m - 4; right = m + 1; }
          const range = [];
          for (let i = 1; i <= m; i++) {
            if (i === 1 || i === m || (i >= left && i < right)) range.push(i);
          }
          const result = [];
          let l;
          for (let i of range) {
            if (l) {
              if (i - l === 2)      result.push(l + 1);
              else if (i - l !== 1) result.push('...');
            }
            result.push(i);
            l = i;
          }
          return result;
        }

        function renderButtons() {
          const total = cards.length;
          const pages = Math.ceil(total / perPage);

          if (!paginationNums || !prevBtn || !nextBtn) return;
          paginationNums.innerHTML = '';

          getPaginationArray(currentPage, pages).forEach(i => {
            if (i === '...') {
              const span = document.createElement('span');
              span.textContent = '...';
              span.className = 'page-number';
              span.style.cursor = 'default';
              paginationNums.appendChild(span);
            } else {
              const btn = document.createElement('button');
              btn.className = 'page-number' + (i === currentPage ? ' active' : '');
              btn.textContent = i;
              btn.addEventListener('click', () => { 
                currentPage = i; 
                render(); 
                section.scrollIntoView({ behavior: 'smooth', block: 'start' });
              });
              paginationNums.appendChild(btn);
            }
          });

          prevBtn.disabled = currentPage === 1;
          nextBtn.disabled = currentPage === pages || pages === 0;

          prevBtn.onclick = () => { if (currentPage > 1)      { currentPage--; render(); section.scrollIntoView({ behavior: 'smooth', block: 'start' }); } };
          nextBtn.onclick = () => { if (currentPage < pages)  { currentPage++; render(); section.scrollIntoView({ behavior: 'smooth', block: 'start' }); } };

          if (pagination) pagination.style.display = pages <= 1 ? 'none' : '';
        }

        if (isDesktop) {
          cards.forEach(card => { card.classList.remove('item'); card.style.display = ''; });
          currentPage = 1;
          render();
        } else if (owlContainer) {
          cards.forEach(card => {
            card.classList.remove('hidden');
            card.style.display = '';
            card.classList.add('item');
          });
          if (pagination) pagination.style.display = 'none';
          
          let owlAttempts = 0;
          function tryOwl() {
            owlAttempts++;
            if (typeof jQuery === 'undefined' || !jQuery.fn.owlCarousel) {
              if (owlAttempts < 100) setTimeout(tryOwl, 100);
              return;
            }
            if (owlContainer.offsetParent !== null) {
              initOwl(owlContainer);
            }
          }
          tryOwl();
        }
      }

      // ── Tab switching ──────────────────────────────────────────────────────
      function switchTab(index) {
        if (index < 0 || index >= tabs.length) return;
        tabs.forEach(t => t.classList.remove('active'));
        contents.forEach(c => c.classList.remove('active'));
        tabs[index].classList.add('active');
        const target = tabs[index].dataset.tab;
        const targetEl = section.querySelector('#' + target);
        if (targetEl) targetEl.classList.add('active');
        activeTabIndex = index;
        paginate(target);
      }

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => switchTab(index));
      });

      if (prevTabBtn) {
        prevTabBtn.addEventListener('click', () => {
          let i = activeTabIndex - 1;
          if (i < 0) i = tabs.length - 1;
          switchTab(i);
        });
      }
      if (nextTabBtn) {
        nextTabBtn.addEventListener('click', () => {
          let i = activeTabIndex + 1;
          if (i >= tabs.length) i = 0;
          switchTab(i);
        });
      }

      if (tabs.length) paginate(tabs[0].dataset.tab);

      // ── Handle Window Resize (DevTools / Device Rotation) ──────────────────
      let currentWidth = window.innerWidth;
      window.addEventListener('resize', function() {
        if (window.innerWidth !== currentWidth) {
          const crossedBreakpoint = (currentWidth > 768 && window.innerWidth <= 768) || (currentWidth <= 768 && window.innerWidth > 768);
          currentWidth = window.innerWidth;
          
          if (crossedBreakpoint) {
            const activeTabBtn = section.querySelector('.system-tab-btn.active');
            if (activeTabBtn) {
              clearTimeout(section.resizeTimer);
              section.resizeTimer = setTimeout(() => {
                paginate(activeTabBtn.dataset.tab);
              }, 150);
            }
          }
        }
      });

      // ── Add to cart ────────────────────────────────────────────────────────
      section.querySelectorAll('form[action$="/cart/add"]').forEach(form => {
        form.addEventListener('submit', function(e) {
          e.preventDefault();
          const btn = form.querySelector('button[type="submit"]');
          if (btn) { btn.disabled = true; btn.style.opacity = '0.5'; }

          fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
            method: 'POST',
            body: new FormData(form)
          })
          .then(r => r.json())
          .then(cart => {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: cart } }));
            const cartIcon = document.querySelector('a[href="/cart"], .header__icon--cart, #cart-icon');
            if (cartIcon) cartIcon.click();
          })
          .catch(err => console.error('Error adding to cart:', err))
          .finally(() => {
            if (btn) { btn.disabled = false; btn.style.opacity = '1'; }
          });
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSystemProductTabs);
  } else {
    initSystemProductTabs();
  }

  document.addEventListener('shopify:section:load', initSystemProductTabs);
  initSystemProductTabs();
})();
